module.exports = __webpack_public_path__ + "img/icon_partner_type_02.0a378404.svg";